'use strict';

window.TIMEOUT_FOR_ONE_BOUNCE_MARKER = 750;

window.TILE_SIZE = 256;

window.PROPRIEDADE_MIN_ZOOM = 5;

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').factory('GoogleMapsService', function($q, $filter) {
  const transformCoordinates = function(coordinates) {
    return coordinates.map(function(coordinate) {
      return new google.maps.LatLng(coordinate[1], coordinate[0]);
    });
  };

  return {
    instances: {},

    // eslint-disable-next-line max-lines-per-function
    addMarkerLabelToPolygon: function(polygon) {
      polygon.addListener('mousemove', function(event) {
        if (this.markerLabel) {
          this.markerLabel.setPosition(event.latLng);
          this.markerLabel.setVisible(true);
          this.markerLabel.set('labelContent', generateLabelContent(this));
        } else {
          this.markerLabel = new MarkerWithLabel({
            position: event.latLng,
            map: polygon.map,
            labelContent: generateLabelContent(this),
            labelAnchor: '40 33',
            labelClass: 'leaflet-label',
            icon: 'images/blank.png'
          });
        }
      });

      polygon.addListener('mouseout', function() {
        if (this.markerLabel) {
          this.markerLabel.setVisible(false);
        }
      });

      function getArrayLabelContent(value, title, separator) {
        value = value || [];
        if (!value.length) {
          return '';
        }

        value = value.map(function(item) {
          return $filter('humanize')(item);
        });

        return `<br>${ title }${value.join(separator || ', ')}`;
      }

      function generateLabelContent() {
        const sorted = polygon.tipos_pragas && polygon.tipos_pragas.sort(function(a, b) {
          return a.localeCompare(b);
        });

        return (polygon.descricao || polygon.gleba.descricao) +
                getArrayLabelContent(sorted, 'Tipos: ', '<br>') +
                getArrayLabelContent(polygon.hint, '', '<br>') +
              (polygon.ultima_pulverizacao ? `<br>Última pulverização:
              ${ $filter('date')(polygon.ultima_pulverizacao)}` : '');
      }
    },

    getPolygons: function(propriedade, map) {
      return propriedade.glebas.reduce(function(result, gleba) {
        const bounds = new google.maps.LatLngBounds();
        const paths = gleba.coordinates.map(function(coordinates) {
          const coords = transformCoordinates(coordinates);

          coords.forEach(function(coord) {
            bounds.extend(coord);
          });

          return coords;
        });

        result[gleba.id] = new google.maps.Polygon({
          paths: paths,
          strokeColor: STROKE_POLYGON.color,
          strokeOpacity: STROKE_POLYGON.opacity,
          strokeWeight: STROKE_POLYGON.weight,
          fillOpacity: FILL_POLYGON.opacity,
          gleba: gleba,
          map: map,
          bounds: bounds
        });

        return result;
      }, {});
    },

    createMapForPropriedade: function(id, propriedade) {
      const defered = $q.defer();

      if (this.instances[id]) {
        delete this.instances[id];
      }
      const map = new google.maps.Map(document.getElementById(id), {
        mapTypeId: google.maps.MapTypeId.SATELLITE,
        streetViewControl: false,
        minZoom: PROPRIEDADE_MIN_ZOOM
      });
      this.instances[id] = map;

      const polygons = this.getPolygons(propriedade, map);
      const bounds = new google.maps.LatLngBounds();
      Object.keys(polygons).forEach(function(key) {
        bounds.extend(polygons[key].bounds.getNorthEast());
        bounds.extend(polygons[key].bounds.getSouthWest());
      });
      map.fitBounds(bounds);

      google.maps.event.addListener(map, 'tilesloaded', function() {
        defered.resolve({
          map: map,
          polygons: polygons,
          bounds: bounds
        });
      });

      return defered.promise;
    },

    refresh: function(instance, bounds) {
      google.maps.event.trigger(instance, 'resize');
      if (bounds) {
        instance.fitBounds(bounds);
        instance.panToBounds(bounds);
      }
    },

    getAreaPolygon: function(polygon) {
      return google.maps.geometry.spherical.computeArea(polygon.getPath());
    },

    getDistance: function(path) {
      return google.maps.geometry.spherical.computeLength(path);
    },

    getCoordinatesFromPolygon: function(polygon) {
      return polygon.getPath().getArray();
    },

    setBounds: function(bounds, map) {
      if (map) {
        map.fitBounds(bounds);
      }
    },

    getPolygonBounds: function(polygon, bounds) {
      bounds = bounds || new google.maps.LatLngBounds();

      polygon.getPath().getArray()
        .forEach(function(coordinate) {
          bounds.extend(coordinate);
        });

      return bounds;
    },

    getPolygonsBounds: function(polygons) {
      const bounds = new google.maps.LatLngBounds();
      const _this = this;

      polygons.forEach(function(polygon) {
        _this.getPolygonBounds(polygon, bounds);
      });

      return bounds;
    },

    getIconForNumberMarker: function(number, bgColor, textColor) {
      return `http://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=
      ${ number }|${ bgColor }|${ textColor || '000000'}`;
    },

    getDrawingModesForTipo: function(tipo) {
      if (tipo === 'plantio_operador') {
        return [google.maps.drawing.OverlayType.POLYGON, google.maps.drawing.OverlayType.POLYLINE];
      }
      return [google.maps.drawing.OverlayType.POLYGON];
    },

    // Converte coordenadas de margem em tiles
    // From: https://developers.google.com/maps/documentation/javascript/examples/map-coordinates
    getTileCoordinate: function(latLng, zoom) {
      /*jshint bitwise: false*/
      const scale = 1 << zoom;
      const worldCoordinate = this.mapProjection(latLng);

      return new google.maps.Point(
        Math.floor(worldCoordinate.x * scale / TILE_SIZE),
        Math.floor(worldCoordinate.y * scale / TILE_SIZE)
      );
    },

    mapProjection: function(latLng) {
      let siny = Math.sin(latLng.lat() * Math.PI / 180);

      siny = Math.min(Math.max(siny, -0.9999), 0.9999);

      return new google.maps.Point(
        TILE_SIZE * ((0.5 + latLng.lng()) / 360),
        TILE_SIZE * (0.5 - Math.log((1 + siny) / ((1 - siny)) / (4 * Math.PI)))
      );
    }
  };
});
